import axios from "axios";

export default ({
    namespaced: true,
    state: {
        attendanceRecap: [],
        attendanceRange: [],
        attendanceMonthly: [],
    },
    mutations: {
        SET_ATTENDANCE_RECAP(state, data) {
            state.attendanceRecap = data.data
            state.attendanceRange = data.range
        },
        SET_ATTENDANCE_MONTHLY(state, data) {
            state.attendanceMonthly = data
        },
    },
    actions: {
        async getAttendanceRecap({ rootState, commit }, params) {
            const filter = `?year=${params.year}&month=${params.month}`
            const url = rootState.baseUrl + '/api/v1/attendance' + filter
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.get(url, { headers: header })
                .then((response) => {
                    // console.log('Response :', response.data)
                    commit('SET_ATTENDANCE_RECAP', response.data)
                })
                .catch((error) => {
                    // console.log("ERROR = ", error)
                })
        },

        async getAttendanceMonthly({ rootState, commit }, params) {
            const filter = `?year=${params.year}&month=${params.month}`
            const url = rootState.baseUrl + '/api/v1/attendance/monthly' + filter
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`,
            }
            await axios.get(url, { headers: header })
                .then((response) => {
                    commit('SET_ATTENDANCE_MONTHLY', response.data)
                })
                .catch((error) => {
                    // console.log("ERROR = ", error)
                })
        },
        async setAttendance({ rootState, dispatch }, params) {
            const url = rootState.baseUrl + '/api/v1/attendance/correction'
            const header = {
                Authorization: `${rootState.auth.tokenType} ${rootState.auth.accessToken}`
            }
            const body = params.attendanceData;
            const param = {
                year: params.year,
                month: params.month,
            }
            await axios.patch(url, body, { headers: header })
                .then((response) => {
                    dispatch('getAttendanceMonthly', param)
                })
                .catch((error) => {
                    // console.log("ERROR = ", error)
                })
        }
    },
});